import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { PassaggioConsegneResponse } from '../models/passaggio-consegne.model';

@Component({
  selector: 'app-passaggio-consegne-display-items',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template:`
    <p-table  [value]="items()" [totalRecords]="items().length" [paginator]="true" [rows]="10">
      <ng-template pTemplate="header">
        <tr>
          <th id="dataPassaggioConsegne" style="width:'90px';">Data/Ora Passaggio di Consegne</th>
          <th id="funzionarioUscente" style="width:'180px';">Funzionario Uscente</th>
          <th id="funzionarioSubentrante" style="width:'180px';">Funzionario Subentrante</th>
          <th id="action-buttons"></th>      
        </tr>
      </ng-template>

      <ng-template pTemplate="body" let-rowData>
        <tr>      
          <td>{{rowData['dataPassaggioConsegne'] | date: 'dd/MM/yyyy HH:mm'}}</td>
          <td>{{rowData['funzionarioUscente']}}</td>
          <td>{{rowData['funzionarioSubentrante']}}</td>
          <td class="action-buttons">
            <button pButton type="button" title="Stampa" icon="fas fa-print" (click)="print.emit(rowData)"></button>
          </td>
        </tr>
      </ng-template>

      <ng-template pTemplate="emptymessage">
        <tr>
          <td colspan=4>
            Nessun passaggio di consegne trovato.
          </td>
        </tr>
      </ng-template>
    </p-table>  
  `,
  styles:[
    `
      :host ::ng-deep td {
        padding: 0.25em 0.5em !important;
        text-align: center;
      }

      .action-buttons {
        display: flex;
        gap: 5px;
      }  
    `
  ]
})
export class PassaggioConsegneDisplayItemsComponent {
  items = input<PassaggioConsegneResponse[]>([]);
  print = output<PassaggioConsegneResponse>();
}